"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("react-hook-schema/core");
const classnames_1 = __importDefault(require("classnames"));
const fieldWrapper_1 = require("./common/fieldWrapper");
const displayWrapper_1 = require("./common/displayWrapper");
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const locale_1 = require("utils/locale");
const hooks_1 = require("./hooks");
const hooks_2 = require("common/hooks");
const MultilineTextSchemaComponent = (props) => {
    const { value, registerProps, fieldState } = (0, core_1.useField)(props, [
        core_1.requiredValidator,
    ]);
    const { schema } = props;
    const [lang, setLang] = (0, hooks_1.useEditingLocale)();
    const multiLangValue = (0, react_1.useMemo)(() => {
        if (typeof value === "object") {
            return value || {};
        }
        return {
            ja: value,
        };
    }, [value]);
    return (react_1.default.createElement(fieldWrapper_1.FieldWrapper, { fieldState: fieldState },
        react_1.default.createElement(Form_1.default.Control, Object.assign({ as: "textarea", className: (0, classnames_1.default)({
                "has-error": fieldState.invalid,
            }), rows: schema.rows || 6, value: multiLangValue[lang] || "" }, registerProps, { onChange: (e) => {
                const newValue = e.target.value;
                if (newValue) {
                    registerProps.onChange((0, locale_1.getMultiLocaleValues)(Object.assign(Object.assign({}, multiLangValue), { [lang]: newValue })));
                }
                else {
                    registerProps.onChange((0, locale_1.getMultiLocaleValues)(Object.assign(Object.assign({}, multiLangValue), { [lang]: undefined })) || null);
                }
            } })),
        react_1.default.createElement(hooks_1.AdminDropdownLocaleSelector, { locales: locale_1.availableLocales })));
};
MultilineTextSchemaComponent.display = (0, displayWrapper_1.DisplayComponent)("MultilineTextDisplayComponent", (value) => {
    if (typeof value === "object") {
        const [lang] = (0, hooks_1.useEditingLocale)();
        return (react_1.default.createElement("div", { style: { whiteSpace: "pre-wrap" } }, (0, hooks_2.resolveStringIntl)(value, lang)));
    }
    return react_1.default.createElement("div", { style: { whiteSpace: "pre-wrap" } }, value);
});
exports.default = MultilineTextSchemaComponent;
